import { defineComponent as n, openBlock as i, createBlock as a, unref as t } from "vue";
import { sizeNameToSize as r } from "@ds/components/Icon";
import m from "../../icons/generated/IconSpinner.vue2.js";
const p = /* @__PURE__ */ n({
  name: "RevSpinner",
  __name: "Spinner",
  props: {
    size: { default: "medium" },
    alternativeText: { default: "Loading" }
  },
  setup(e) {
    return (o, s) => (i(), a(t(m), {
      "alternative-text": e.alternativeText,
      class: "animate-spin text-inherit",
      size: t(r)[e.size]
    }, null, 8, ["alternative-text", "size"]));
  }
});
export {
  p as default
};
